import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import store from "./store/store";
import { BrowserRouter as Router } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.css';
//import 'react-bootstrap-country-select/dist/react-bootstrap-country-select.css';

// core components
import './assets/css/material-dashboard-react.css?v=1.6.0';
import './assets/css/style.css?v=1.6.0';
import App from './App';

//STEP 1:
//create components using React.lazy
const EnglishTheme = React.lazy(() => import("./Themes/ThemeEn"));
const ArabicTheme = React.lazy(() => import("./Themes/ThemeAr"));

//STEP 2:
//create a parent component that will load the components conditionally using React.Suspense
const ThemeSelector = ({ children }: any) => {
    const CHOSEN_THEME = localStorage.getItem("preferred_lang") || "en";
    return (
        <>
            <React.Suspense fallback={<></>}>
                {CHOSEN_THEME === "en" && <EnglishTheme />}
                {CHOSEN_THEME === "ar" && <ArabicTheme />}
            </React.Suspense>
            {children}
        </>
    );
};

const baseUrl = (window.location.hostname == 'localhost') ? process.env.REACT_APP_HOST : "/ticket/build";

ReactDOM.render(<Router basename={baseUrl}>
    <Provider store={store}>
        <ThemeSelector>
            <App />
        </ThemeSelector>
    </Provider>
</Router>, document.getElementById('root'));

// f you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// learn more about service workers: https://bit.ly/CRA-PWA
